import { AfterViewInit, Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { IconsService } from 'src/app/shared/services/icons.service';
import { SettlementsService } from '../services/settlements.service';
import { ToastrService } from 'ngx-toastr';
import { ModalAddContractComponent } from 'src/app/components/modals/modal-add-contract.component';
import { Settlement } from 'src/app/models/settlement.model';
import { Unit } from 'src/app/models/unit.model';
import { Tanque } from 'src/app/models/tanque.model';

@Component({
  selector: '[app-contract-unit]',
  template: `
    <div class="d-flex">
      <div>
        <h5 class="mt-2">Contratos</h5>
      </div>
      <div class="ms-auto">
        <button class="btn btn-outline-secondary btn-sm" (click)="createContract()">
          <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon> Agregar
        </button>
      </div>
      <app-modal-add-contract
      [contractTypes]="contractTypes"
      [settlement]="settlement"
      [tenants]="tenants"
      [unit]="unit"
      [tanque]="tanque"
      [profile]="profile"
    ></app-modal-add-contract>
    </div>
    <div class="row" *ngIf="contracts.length==0">
      <div class="col-12 text-center my-3">
        <div class="list-group">
          <div class="list-group-item pt-5 pb-5">
            Sin contratos asignados
        </div>
      </div>
    </div>
    <div class="row" *ngIf="contracts.length > 0">        
      <div class="col-12"> 
        <div class="list-group">
          <div app-item-contract
            [contract]="contract"
            [contractTypes]="contractTypes"
            class="list-group-item list-group-item-action" 
            *ngFor="let contract of contracts | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries}"
          ></div>
        </div>
      </div>
      <div class="col-md-12 text-end mt-3" >
        <pagination-controls
          (pageChange)="p = $event"
          (pageChange)="pageChanged($event)"
          previousLabel="Prev."
          nextLabel="Sig."
          screenReaderPaginationLabel="Pagination"
          screenReaderPageLabel="page"
          *ngIf="contracts.length>0"
        ></pagination-controls>
      </div>
    </div>
  `,
  styles: []
})
export class ContractUnitComponent implements AfterViewInit {
  @Input() settlement: Settlement | null = null;
  @Input() unit: Unit | null = null;
  @Input() profile: any;
  @Input() permissions: any;
  @Input() tanque: Tanque | null = null;
  @Input() tenants: any;
  @ViewChild(ModalAddContractComponent, { static: true }) modalAddContractComponent !: ModalAddContractComponent; 
  
  contracts: any[] = [];
  contractTypes: any[] = [];

  payload: any = {
    page: 1,
    per_page: 5,
  };

  meta: any;
  p: number = 1;

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService
  ) {}

  ngAfterViewInit(): void {
    this.store.getContractTypes({ is_active: true }).subscribe((data:any) => {
      // console.log('load CONTRACT TYPES => ', data);
      this.contractTypes = data.data;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['unit']&&changes['unit'].currentValue) {
      if (changes['unit'].currentValue.id) {
        this.loadContracts();
      }
    }
    if (changes['contracts']&&changes['contracts'].currentValue) {
      // console.log('CONTRACTS ====> ', changes['contracts'].currentValue);
    }
    if (changes['settlement']&&changes['settlement'].currentValue) {
      // console.log('STLS ====> ', changes['settlement'].currentValue);
    }
    if (changes['tenants']&&changes['tenants'].currentValue) {
      console.log('changes contract unit TENANTS ====> ', changes['tenants'].currentValue);
    }
  }

  loadContracts(): void {
    this.payload.unit_id = this.unit?.id;
    this.store.getContracts(this.payload).subscribe({
      next: (data: any) => {
        this.contracts = data.data;
        this.meta = data.meta;
      },
      error: (error: any) => {
        console.log('error => ', error);
        this.toastr.error('No se pudieron cargar los contratos', 'Error');
      }
    });
  }

  createContract(): void {
    const modalTemplate: any | undefined = this.modalAddContractComponent;
    console.log('modalTemplate => ', modalTemplate);
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalAddContract']);
    }
  }

  pageChanged(event: any): void {
    this.payload.page = event;
    this.loadContracts();
  }
}
